import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import ProjectDetail from "./pages/ProjectDetail";
import ProjectComparison from "./pages/ProjectComparison";
import Career from "./pages/Career";
import AdminDashboard from "./pages/AdminDashboard";
import LiveChat from "./components/LiveChat";

function App() {
  return (
      <div className="App">
            <BrowserRouter>
                    <Routes>
                              <Route path="/" element={<Home />} />
                                        <Route path="/project/:id" element={<ProjectDetail />} />
                                                  <Route path="/compare" element={<ProjectComparison />} />
                                                            <Route path="/careers" element={<Career />} />
                                                                      <Route path="/admin" element={<AdminDashboard />} />
                                                                              </Routes>
                                                                                      <LiveChat />
                                                                                            </BrowserRouter>
                                                                                                  <Toaster position="top-right" />
                                                                                                      </div>
                                                                                                        );
                                                                                                        }

                                                                                                        export default App;
                                                                                                        